import React from 'react';
import style from './quoteCargoTypeInformation.module.scss';
import classNames from 'classnames';
import { CargoTypeInformation } from 'acscp/api/models/cargoTypeInformation';

export const QuoteCargoTypeInformation: React.FC<{
    cargoTypeInformation: CargoTypeInformation[],
}> = ({cargoTypeInformation}) => {
    return (
        <div className={classNames(style.MainContainer)}>
            {cargoTypeInformation.map((cti, index) => (
                <div
                    key={`cargoTypeInformationContainer-${index}`}
                    className={classNames(style.CargoTypeInformationContainer)}
                >
                    {cti.name && <h3>{cti.name.toUpperCase()}</h3>}
                    <div
                        key={index}
                        dangerouslySetInnerHTML={{__html: cti.description}}
                    />
                    <div className={classNames(style.CargoTypeInformationImagesContainer)}>
                        {cti.images.map(image => (
                            <div
                                key={`${image.url}-container`}
                                className={classNames(style.CargoTypeInformationImageContainer)}
                            >
                                <div className={classNames(style.ImageContainer)}>
                                    <img
                                        key={image.url}
                                        src={image.url}
                                        alt={image.displayName || ''}
                                        className={classNames(style.Image)}
                                    />
                                </div>

                                <div>{image.displayName}</div>
                            </div>
                        ))}
                    </div>
                </div>
            ))}
        </div>
    );
};
